<template>
  <div class="d-flex flex-center">
    <div
      class="card shadow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    >
      <div class="card-header">
        <h3 class="card-title">
          <img src="media/icons/duotune/files/fil002.svg" class="me-2" />Plano
          de Contas
        </h3>
        <div
          v-if="this.modal === true"
          class="btn btn-icon btn-sm btn-active-light-primary mt-6"
          data-bs-dismiss="modal"
          @click="this.$emit('fecharConta', false)"
        >
          <span class="svg-icon svg-icon-2x">
            <img src="media/icons/duotune/arrows/arr061.svg" />
          </span>
        </div>
      </div>
      <div class="card-body p-0">
        <div class="card-header border-0 pt-5">
          <div class="card-title">
            <div class="d-flex align-items-center position-relative my-1">
              <span class="svg-icon svg-icon-1 position-absolute ms-6">
                <inline-svg src="media/icons/duotune/general/gen004.svg" />
              </span>
              <input
                type="text"
                id="txtPesquisarContas"
                v-model="pesquisa"
                @input="onSearch($event.target.value)"
                class="form-control form-control-solid w-250px ps-15"
                placeholder="Pesquisar Contas"
              />
            </div>
          </div>
          <div class="card-toolbar">
            <button
              v-if="this.adicionar"
              @click="adicionarConta(null)"
              class="btn btn-sm btn-primary"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/general/gen041.svg" /></span
              >Adicionar
            </button>
          </div>
        </div>
        <div class="card-body pt-0">
          <div :class="[loading && 'overlay overlay-block']">
            <div
              v-if="loading"
              class="overlay-layer card-rounded bg-dark bg-opacity-5"
            >
              <div class="spinner-border text-primary" role="status"></div>
              <span class="ms-2">Aguarde, carregando...</span>
            </div>
            <div class="custom-tree-container border p-2">
              <el-tree
                ref="treeRef"
                :data="this.data"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                :props="propsTree"
                :empty-text="emptyText"
                :highlight-current="true"
                default-expand-all
                @node-click="selecionarRegistro($event)"
              >
                <template #default="{ data, node }">
                  <span v-if="data.id === 0" class="svg-icon svg-icon-1 me-3">
                    <inline-svg src="media/icons/duotune/files/fil002.svg"
                  /></span>
                  <span v-else class="svg-icon svg-icon-1 me-3">
                    <inline-svg
                      v-if="data.Contas && data.Contas.length > 0"
                      src="media/icons/duotune/files/fil012.svg" /><inline-svg
                      v-else
                      src="media/icons/duotune/files/fil003.svg"
                  /></span>
                  <span class="custom-tree-node">
                    <span>{{ node.label }}</span>
                  </span>
                  <span v-if="data.id > 0" class="col-auto ms-auto">
                    <button
                      :id="`btnAdicionarConta${data.id}`"
                      v-if="this.adicionar"
                      @click="adicionarConta(data)"
                      class="btn btn-sm btn-light-primary py-0 px-1 ms-4"
                    >
                      <span class="svg-icon svg-icon-1 me-0">
                        <inline-svg
                          src="media/icons/duotune/general/gen035.svg"
                      /></span>
                    </button>
                    <button
                      v-if="this.editar"
                      @click="editarConta(data)"
                      class="btn btn-sm btn-light-info py-0 px-1 ms-1"
                    >
                      <span class="svg-icon svg-icon-1 me-0">
                        <inline-svg
                          src="media/icons/duotune/general/gen055.svg"
                      /></span>
                    </button>
                    <button
                      v-if="this.excluir"
                      @click="removerRegistro(data, node)"
                      class="btn btn-sm btn-light-danger py-0 px-1 ms-1"
                    >
                      <span class="svg-icon svg-icon-1 me-0">
                        <inline-svg src="media/icons/duotune/files/fil015.svg"
                      /></span>
                    </button>
                  </span>
                </template>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ContaModal
    v-if="exibirConta"
    @cancelarConta="modalConta"
    @confirmarConta="confirmarConta"
    :idConta="idConta"
    :conta="conta"
  ></ContaModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ContaModal from "@/views/contas/ContaModal.vue";
import { hideModalId, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { mapState } from "vuex";
import _ from "lodash";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: ["selecionarConta", "fecharConta", "adicionarConta", "editarConta"],
  components: { ContaModal },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async confirmarConta() {
      this.modalConta(false);
      hideModalId("kt_modal_conta_editar");
      await this.carregarContas();
      this.focusCurrentNode();
    },
    focusCurrentNode() {
      var node = this.$refs.treeRef.getCurrentNode();
      if (node !== null) {
        setTimeout(() => {
          this.nextFocus("btnAdicionarConta" + node.id);
        }, 500);
      }
    },
    async adicionarConta(data) {
      if (data === null) {
        if (this.modal === true) {
          this.$emit("adicionarConta", null);
        } else {
          this.idConta = 0;
          this.conta = null;
          this.modalConta(true);
        }
      } else {
        var alert = await Swal.fire({
          text: "Deseja incluir um grupo mãe?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          if (this.modal === true) {
            this.$emit("adicionarConta", null);
          } else {
            this.idConta = 0;
            this.conta = null;
            this.modalConta(true);
          }
        } else {
          if (this.modal === true) {
            this.$emit("adicionarConta", data);
          } else {
            this.idConta = 0;
            this.conta = data;
            this.modalConta(true);
          }
        }
      }
    },
    editarConta(data) {
      if (this.modal === true) {
        this.$emit("editarConta", data);
      } else {
        this.idConta = data.id;
        this.conta = data;
        this.modalConta(true);
      }
    },
    modalConta(exibir) {
      this.exibirConta = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_conta_editar");
        }, 100);
      }
    },
    onSearch(pesquisa) {
      this.$refs.treeRef.filter(pesquisa);
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      } else {
        return data.descricao
          .toUpperCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            value
              .toUpperCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
      }
    },
    async removerRegistro(data, node) {
      var alert = await Swal.fire({
        text: "Deseja remover o registro?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.loading = true;
        try {
          var ret = await this.$store.dispatch("conta/deleteConta", data.id);
          if (ret.Success === true) {
            await this.carregarContas();
            toast.success("Conta excluída com sucesso!", { timeout: 3000 });
          }
        } catch (error) {
          toast.error(error.Message, { timeout: 3000 });
        }
        this.loading = false;
      }
    },
    async selecionarRegistro(conta) {
      if (this.modal === true) {
        setTimeout(this.limparContaSelecionada, 500);
        if (this.contaSelecionada === 0) {
          this.contaSelecionada = conta.id;
        } else {
          if (this.contaSelecionada === conta.id) {
            if (conta.Contas === null) {
              this.$emit("selecionarConta", conta);
            } else {
              await Swal.fire({
                text: "Não é possível selecionar um nível superior!",
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: "btn fw-bold btn-warning",
                },
              });
            }
            this.limparContaSelecionada();
          } else {
            this.contaSelecionada = conta.id;
          }
        }
      }
    },
    limparContaSelecionada() {
      this.contaSelecionada = 0;
    },
    async carregarContas() {
      this.loading = true;
      this.pesquisa = "";
      try {
        var ret = await this.$store.dispatch("conta/getAllConta");
        if (ret.Success === true) {
          if (ret.Data !== null) {
            this.contas = _.groupBy(ret.Data, "resultado");
            this.data.splice(0, this.data.length);

            for (var prop in this.contas) {
              var tipo = {
                id: 0,
                conta: "",
                descricao: prop,
                Contas: this.contas[prop],
              };
              this.data.push(tipo);
            }
          }
        }
      } catch (error) {
        toast.error(error.Message, { timeout: 3000 });
      }
      this.loading = false;
      this.emptyText = "Nenhuma conta foi encontrada";
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Conta.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.Conta.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.Conta.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    await this.carregarContas();
    setTimeout(() => {
      this.nextFocus("txtPesquisarContas");
    }, 800);
  },
  data() {
    return {
      contaSelecionada: 0,
      idConta: 0,
      exibirConta: false,
      conta: {},
      loading: false,
      adicionar: false,
      editar: false,
      excluir: false,
      pesquisa: "",
      emptyText: "",
      data: [],
      contas: [],
      propsTree: {
        children: "Contas",
        label: "descricao",
      },
    };
  },
};
</script>

<style></style>
